import * as $ from 'jquery';

window.initExport = (filters) => {
    $('.js-api-export').off(); // unbind any previous binds;
    $('.js-api-export').on('click', function (e) {
        const exportBtn = $('.js-export-btn');
        const defaultExportText = exportBtn.html();
        const spinner = $('<i class="fas fa-spinner fa-spin"></i> <span></span>');

        spinner.siblings('span').text('Sending, please wait...');
        exportBtn.html(spinner).prop('disabled', true);

        apiClient
            .create('Submission')
            .export(filters)
            .then(function (response) {
                spinner.siblings('span').text('Document queued, please wait...');
                exportBtn.html(spinner);
            })
            .catch(function (error) {
                exportBtn.html(defaultExportText).prop('disabled', false);

                ca.notify({
                    type: 'error',
                    message: 'Failed to export data. CA support staff have been notified. Sorry for the inconvenience.',
                    timeout: ca.config('toast.timeout'),
                });
            });
    });
};
